import React, { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import BusinessTypeSelection from './BusinessTypeSelection';
import LocationDetails from './LocationDetails';
import Review from './Review';
import { Toast } from 'primereact/toast';
import { BusinessTypeValue } from './types'; // Importáljuk a típust

interface Business {
  name: string;
  place_id: string;
  address: string;
}

interface StepperFormProps {
  business: Business;
}

const StepperForm: React.FC<StepperFormProps> = ({ business }) => {
  const [activeStep, setActiveStep] = useState(0); // Aktív lépés
  const [businessType, setBusinessType] = useState<BusinessTypeValue>('single'); // Alapértelmezett érték: 'single'
  const [locations, setLocations] = useState<any[]>([]);
  const [franchiseName, setFranchiseName] = useState<string>('');
  const toastRef = useRef<any>(null); // A Toast referencia

  const nextStep = () => {
    if (!businessType) {
      toastRef.current.show({
        severity: 'error',
        summary: 'Hiba!',
        detail: 'Kérjük válasszon egy business type-t!',
        life: 3000,
      });
      return; // Megállítjuk a továbblépést
    }
    setActiveStep((prev) => Math.min(prev + 1, 2)); // Egyébként léphetünk tovább
  };

  const prevStep = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0)); // Visszalépés
  };

  const handleChangeStep = (e: { index: number }) => {
    setActiveStep(e.index);
  };

  return (
    <div className="stepper-container">
      <Toast ref={toastRef} /> {/* A Toast komponens elhelyezése */}

      <Stepper activeStep={activeStep} onChangeStep={handleChangeStep}>
        <StepperPanel header="Business Registration">
          {/* Átadjuk a businessType állapotot és a setBusinessType-t */}
          <BusinessTypeSelection
            businessType={businessType} // Most már biztos, hogy nem null
            setBusinessType={setBusinessType} // Átadjuk a setBusinessType-ot
          />
        </StepperPanel>

        <StepperPanel header="Location Details">
          <LocationDetails
            franchiseName={franchiseName}
            setFranchiseName={setFranchiseName}
            locations={locations}
            setLocations={setLocations}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        </StepperPanel>

        <StepperPanel header="Review">
          <Review
            businessType={businessType} // Most már nem null, hanem mindig string lesz
            franchiseName={franchiseName}
            locations={locations}
            prevStep={prevStep}
            nextStep={nextStep}
          />
        </StepperPanel>
      </Stepper>

      <div className="p-d-flex p-jc-between p-mt-4 stepper-buttons">
        {activeStep > 0 && (
          <Button 
            label="Previous" 
            icon="pi pi-arrow-left" 
            onClick={prevStep} 
            className="p-button-secondary" 
          />
        )}
        {activeStep < 2 && (
          <Button 
            label="Next" 
            icon="pi pi-arrow-right" 
            onClick={nextStep} 
            className="p-button-primary" 
          />
        )}
      </div>
    </div>
  );
};

export default StepperForm;
